import axios from "axios";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { MutateLineOfPoetryDTO } from "../../dto";

type CreateLineOfPoetryProps = {
  audioYoung: File;
  audioOld: File;
  text: string;
  poetryId: string;
  stanza: string;
  unit: string;
};

let body: MutateLineOfPoetryDTO;

export async function createLineOfPoetryAction(props: CreateLineOfPoetryProps) {
  const token = localStorage.getItem("token");

  const params = new FormData();
  params.append("audioYoung", props.audioYoung);
  params.append("audioOld", props.audioOld);
  params.append("text", props.text);
  params.append("poetryId", props.poetryId);
  params.append("stanza", props.stanza);
  params.append("unit", props.unit);

  return await axios
    .post(
      `${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/lines-of-poetries/create`,
      params,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "app-platform": "cms",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then(async (res) => {
      body = plainToClass(MutateLineOfPoetryDTO, res.data);
      await validate(body);
      const errors = await validate(body);
      if (errors.length > 0) {
        throw errors;
      }

      return res.data;
    });
}
